var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"inspectButton",staticClass:"cz2__inspect-trigger",class:[
        _vm.inspectOverlay ? 'is-full-size' : 'selection-card__inspect',
    ],attrs:{"type":"button","aria-label":`${_vm.$t('INSPECT')} ${_vm.ariaLabelText}`},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[(_vm.inspectOverlay)?_c('span',{staticClass:"selection-card__inspect"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }